var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('fullscreen'),_c('div',{staticClass:"darken"},[_c('navbar'),_c('spacer'),_c('router-view'),(_vm.$router.currentRoute.name !== 'Credits')?_c('footbar'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }